import { render, staticRenderFns } from "./BuyerClaimContactInfoCard.vue?vue&type=template&id=286a4379&scoped=true"
import script from "./BuyerClaimContactInfoCard.vue?vue&type=script&lang=js"
export * from "./BuyerClaimContactInfoCard.vue?vue&type=script&lang=js"
import style0 from "./BuyerClaimContactInfoCard.vue?vue&type=style&index=0&id=286a4379&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286a4379",
  null
  
)

export default component.exports